import { Grid, Fade, Typography, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import {
  StyledTextField,
  StyledFormButton,
  StyledFormContainer,
  StyledFormSection,
} from "../../utils/formStyles";

interface Props {
  value?: string | null;
  onAddClient?: (name: string) => void;
  onEditClient?: (name: string) => void;
  onCancel: () => void;
}

export const AddClientForm = ({
  value,
  onAddClient,
  onEditClient,
  onCancel,
}: Props) => {
  const [clientName, setClientName] = useState(value || "");
  const [toSave, setToSave] = useState(false);

  useEffect(() => {
    if (clientName !== "") setToSave(true);
  }, [clientName]);

  return (
    <Fade in timeout={600}>
      <StyledFormContainer>
        <StyledFormSection>
          <Typography
            variant="h5"
            component="h2"
            sx={{ color: "primary.main", fontWeight: 600, mb: 1 }}
          >
            Client
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={3}>
            <Grid item lg={6} xs={12}>
              <StyledTextField
                type="text"
                label="Name"
                variant="outlined"
                name="name"
                value={clientName}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setClientName(event.target.value)
                }
                fullWidth
                required
              />
            </Grid>
          </Grid>
        </StyledFormSection>

        <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
          <Grid item>
            <StyledFormButton
              onClick={onCancel}
              variant="outlined"
              sx={{ minWidth: 120 }}
            >
              Cancel
            </StyledFormButton>
          </Grid>
          {onAddClient && (
            <Grid item>
              <StyledFormButton
                onClick={() => onAddClient(clientName)}
                variant="contained"
                disabled={!toSave}
                sx={{ minWidth: 120 }}
              >
                Add Client
              </StyledFormButton>
            </Grid>
          )}
          {onEditClient && (
            <Grid item>
              <StyledFormButton
                onClick={() => onEditClient(clientName)}
                variant="contained"
                disabled={!toSave}
                sx={{ minWidth: 120 }}
              >
                Update Client
              </StyledFormButton>
            </Grid>
          )}
        </Grid>
      </StyledFormContainer>
    </Fade>
  );
};
